import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Empty, Spin } from 'antd';
import styles from './FuelTransactionTimeline.styles';
import TimelineItem from '../TimeLine/TimelineItem';
import { selectSelectedFuelTransaction } from '../../redux/store/userData/fuelTransactions';
import {
  fetchVehicleEventsForFuelTransaction,
  selectFuelTransactionEvents,
  selectLoadingVehicleEvents,
} from '../../redux/store/userData/vehicleEvents';

const FuelTransactionTimeline: React.FC = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const fuelTransaction = useSelector(selectSelectedFuelTransaction);
  const vehicleEvents: any[] | null = useSelector(selectFuelTransactionEvents);
  const isLoading = useSelector(selectLoadingVehicleEvents);
  const { id, carId, uniqueId, timestamp } = fuelTransaction || {};

  useEffect(() => {
    if (carId && uniqueId) {
      dispatch(
        fetchVehicleEventsForFuelTransaction({ id, carId, uniqueId, timestamp })
      );
    }
  }, [id, carId, uniqueId, timestamp]);

  const isEmpty = !vehicleEvents?.length;

  return (
    <>
      {isEmpty ? (
        <div className="fuel-transaction-timeline-empty">
          {isLoading ? (
            <Spin />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={intl.formatMessage({
                id: 'fleetadmin.fuelTransactions.timeline.empty',
                defaultMessage: 'No fuel session events found',
              })}
            />
          )}
        </div>
      ) : (
        <div
          className="timeline-wrapper"
          data-testid="FuelTransactionTimeline-list"
        >
          {vehicleEvents!.map((ve, i) => (
            <TimelineItem
              key={`fuelTransactionEvents-${i}`}
              vehicleEvent={{ ...ve, fuelTransactionDetails: fuelTransaction }}
              hideFirstBar={i === 0}
              hideSecondBar={i === vehicleEvents!.length - 1}
            />
          ))}
        </div>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default FuelTransactionTimeline;
